(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTemplateDialogController', PatientTemplateDialogController);

    PatientTemplateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatientTemplate', 'Patient', 'Corporation'];

    function PatientTemplateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatientTemplate, Patient, Corporation) {
        var vm = this;

        vm.patientTemplate = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.patientTemplate.id !== null) {
                PatientTemplate.update(vm.patientTemplate, onSaveSuccess, onSaveError);
            } else {
                PatientTemplate.save(vm.patientTemplate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:patientTemplateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
